import User from 'domain/user';

class ProjectLocationPermissions {
  canCreate = (user) => User.isAdminOrSubscriber(user);

  canEdit = (user) => User.isAdminOrSubscriber(user);
}

export default new ProjectLocationPermissions();
